var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 820.7 1305.5",
    style: {
      enableBackground: "new 0 0 820.7 1305.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000075878912566258015430000008127848098136914604_);fill:#FC7685;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 820.7,
    height: 1305.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090980963881652956360000001245086354815722155_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000090980963881652956360000001245086354815722155_)",
      fill: "#FC7685"
    },
    d: "M307.8,1099.4 c17.5,27.2,48.1,40.9,91.7,40.9c35.1,0,62.9-8.2,83.5-24.5c20.6-16.3,36.6-39,48.1-68.1c11.5-29.1,19.1-63.5,22.7-103.5 s5.4-83.5,5.4-130.7v-61.7h-3.6c-21.8,32.7-53,59-93.5,79c-40.6,20-89.9,30-148,30c-56.9,0-105.3-10-145.3-30 c-39.9-20-72.3-47.8-97.1-83.5c-24.8-35.7-43-78.1-54.5-127.1C5.7,571,0,517.5,0,459.4C0,310.5,33,196.7,99,118 C164.9,39.3,270.5,0,415.8,0c89.6,0,161,16.7,214.2,49.9c53.2,33.3,94.1,77.5,122.6,132.5C781,237.6,799.5,301.4,808,374 c8.5,72.6,12.7,148.3,12.7,227c0,92-2.7,180.7-8.2,266c-5.4,85.3-21.8,160.7-49,226.1c-27.2,65.4-70.2,117.1-128.9,155.2 c-58.7,38.1-140.7,57.2-246,57.2c-46,0-90.5-4.5-133.5-13.6c-43-9.1-80.8-26-113.5-50.8c-32.7-24.8-59-58.1-79-99.9 c-20-41.8-30.6-93.5-31.8-155.2h250.6C281.4,1034.3,290.2,1072.2,307.8,1099.4 M294.1,611.9c21.8,37.5,58.1,56.3,108.9,56.3 c52,0,89-18.8,110.8-56.3c21.8-37.5,32.7-99.9,32.7-187c0-36.3-1.8-70.2-5.4-101.7c-3.6-31.5-10.6-58.4-20.9-80.8 c-10.3-22.4-24.8-39.9-43.6-52.7c-18.8-12.7-43.3-19.1-73.5-19.1c-31.5,0-56.6,6.4-75.4,19.1c-18.8,12.7-33,30.6-42.7,53.6 c-9.7,23-16.1,49.9-19.1,80.8c-3,30.9-4.5,64.5-4.5,100.8C261.5,512,272.4,574.4,294.1,611.9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo09);
export default __webpack_public_path__ + "static/media/no-09.cd959ae367e1a85d05548bb85f0b6703.svg";
export { ForwardRef as ReactComponent };